
import PageHeader from "./header/index.vue";
import PageFooter from "./footer/index.vue";

export default {
	name: 'LandingLayout',
	components: { PageHeader, PageFooter },
	middleware: 'auth',
	computed: {
		styles ()
		{
			return {
				'--navbar-height': (this.$vuetify.breakpoint.smAndDown ? 104 : 160) + 'px',
			};
		},
	},
};
